import { cartDB } from 'assets/helpers/cart-db';
import { LocalStorage } from 'quasar';
import { ADD_TO_CART, SET_CHECK } from 'src/store/localStorage/mutations';

async function SET_LOCAL_DATA_DB(context) {
    try {
        const tokenDb = LocalStorage.getItem('tokenDb');
        if (tokenDb) {
            const data = await cartDB.getItem(tokenDb);
            if (data) {
                context.commit('localStorage/SET_LOCAL_DATA', data, { root: true });
            } else {
                context.commit('localStorage/SET_LOCAL_DATA', null, { root: true });
                const store = context.rootState['localStorage'];
                await cartDB.addItem(store);
            }
        } else {
            context.commit('localStorage/SET_LOCAL_DATA', null, { root: true });
        }
    } catch (error) {
        console.error('Ошибка при получении данных из IndexedDB:', error);
    }
}

async function SAVE_LOCAL_DATA(context, payload) {
    const data = await cartDB.getItem(LocalStorage.getItem('tokenDb'));
    context.commit('localStorage/ADD_TO_CART', payload, { root: true });
    const store = context.rootState['localStorage'];
    await cartDB.addItem(store);

}

async function DELETE_ITEM(context, payload) {
    context.commit('localStorage/DELETE_ITEMS', payload, { root: true });
    const store = context.rootState['localStorage'];
    await cartDB.updateItem(store);
}

async function DELETE_CHECK_ITEMS(context, payload) {
    context.commit('localStorage/DELETE_CHECK_ITEMS', payload, { root: true });
    await cartDB.deleteCheckItems(payload);
}

async function UPDATE_LOCAL_DATA(context, payload) {
    context.commit('localStorage/SET_AMOUNT', payload, { root: true });
    const store = context.rootState['localStorage'];
    await cartDB.updateItem(store);
}

async function ADD_FAVOURITE_PRODUCT(context, id) {
    context.commit('localStorage/ADD_FAVOURITE_PRODUCT', id, { root: true });
    await cartDB.updateFavourite(id, true);
};

async function DELETE_FAVOURITE_PRODUCT(context, id) {
    context.commit('localStorage/DELETE_FAVOURITE_PRODUCT', id, { root: true });
    await cartDB.updateFavourite(id, false);
};

async function CLEAR_CART(context, payload) {
    context.commit('localStorage/CLEAR_CART', null, { root: true });
    const store = context.rootState['localStorage'];
    await cartDB.updateItem(store);
}

async function CLEAR_FAVOURITES(context, payload) {
    context.commit('localStorage/DELETE_ALL_FAVOURITES', null, { root: true });
    const store = context.rootState['localStorage'];
    await cartDB.updateItem(store);
}

async function SET_CHECK_ITEM(context, id) {
    context.commit('localStorage/SET_CHECK', id, { root: true });
    const store = context.rootState['localStorage'];
    await cartDB.updateItem(store);
}

async function SET_CHECK_ALL_ITEM(context, checked) {
    context.commit('localStorage/SET_CHECK_ALL', checked, { root: true });
    await cartDB.setCheckAllItems(checked);
}

export {
    SAVE_LOCAL_DATA,
    SET_LOCAL_DATA_DB,
    UPDATE_LOCAL_DATA,
    DELETE_ITEM,
    ADD_FAVOURITE_PRODUCT,
    DELETE_FAVOURITE_PRODUCT,
    CLEAR_CART,
    DELETE_CHECK_ITEMS,
    SET_CHECK_ITEM,
    SET_CHECK_ALL_ITEM,
    CLEAR_FAVOURITES,
};